<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "ModuleProducer",
    data() {
      return {
        data: "",
        list: [{
          name: "沃特玛",
          value: "1"
        }]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;

      }
    }
  }
</script>

<style scoped>

</style>
